import { render, staticRenderFns } from "./MasterSalarySingle.vue?vue&type=template&id=2b16f713&scoped=true"
import script from "./MasterSalarySingle.vue?vue&type=script&lang=js"
export * from "./MasterSalarySingle.vue?vue&type=script&lang=js"
import style0 from "./MasterSalarySingle.vue?vue&type=style&index=0&id=2b16f713&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16f713",
  null
  
)

export default component.exports